import {FC} from 'react'
import {ClientEditModalHeader} from './ClientEditModalHeader'
import {ClientEditModalFormWrapper} from './ClientEditModalFormWrapper'
import {Modal} from 'react-bootstrap'
import { ID } from '../../../helpers'

type Props = {
  show: boolean
  handleClose: () => void | undefined
  clientId: ID | undefined
  initialClientName?: string
}

const ClientEditModal: FC<Props> = ({show, handleClose, clientId, initialClientName}) => {
  return (
    <>
    {/* 
    //@ts-ignore */}
      <Modal
        className='modal'
        id='kt_modal_edit_client'
        tabIndex={-1}
        dialogClassName='modal-dialog modal-md modal-dialog-centered'
        show={show}
        onHide={handleClose}
        backdrop='static'
        enforceFocus={false}
      >
        <ClientEditModalFormWrapper handleClose={handleClose} clientId={clientId} initialClientName={initialClientName} />
      </Modal>
    </>
  )
}

export {ClientEditModal}
